/* eslint-disable prettier/prettier */
/* Title: Profile Reducer
 * Description:
 * Author: Majeed
 * Date: 2021-09-30
*/

import {FETCH_PROFILE, FETCH_PROFILE_DATA, PROFILE_LOADING}  from './profileActionTypes';


const profileInitialState ={
     profileData:{
          name: 'Tuhin',
          complete: 75,
          image:'https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=296&q=80',
     },
     vendor: {},
     loading: false,
}

// Reduce fn(state,action)

const profileReducer = (state=profileInitialState, {type, payload}) => {
     switch (type) {
          case FETCH_PROFILE:
               return {
                    ...state,
                    profileData: payload
               }
          case FETCH_PROFILE_DATA:
               return {
                    ...state,
                    vendor: payload
               }
          case PROFILE_LOADING:
               return {
                    ...state,
                    loading:payload
               }
          default:
               return state;
     }
}

export default profileReducer;